import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Projects from "@/components/Projects";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import GrupLanding from "@/pages/GrupLanding";
import ComingSoon from "@/pages/ComingSoon";
import DizajnSite from "@/pages/DizajnSite";
import { setFavicon } from "@/lib/favicon";
import { setCanonical } from "@/lib/seo";
import { Toaster } from "@/components/ui/sonner";
import WhatsAppFab from "@/components/WhatsAppFab";

const GradnjaSite = () => {
  useEffect(() => {
    document.title = "Nova-Stron gradnja";
    setFavicon("/favicon-32.png");
    setCanonical("https://nova-stron.eu/gradnja");
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <About />
      <Projects />
      <Contact />
      <Footer />
      <WhatsAppFab />
    </div>
  );
};

function App() {
  const isDizajnDomain = window.location.hostname.includes("nova-stron-dizajn");
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={isDizajnDomain ? <DizajnSite /> : <GrupLanding />} />
        <Route path="/gradnja" element={<GradnjaSite />} />
        <Route path="/dizajn" element={<DizajnSite />} />
        <Route path="/svjetiljke" element={<ComingSoon title="Dizajnerske svjetiljke" />} />
        <Route path="/vino" element={<ComingSoon title="Vino" />} />
        <Route path="*" element={isDizajnDomain ? <DizajnSite /> : <GrupLanding />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
